import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35273b79"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-error",
  testid: "modal-error"
}

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { getFundingError } from './get-funding-error';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalError',
  props: {
  error: { type: [String, Object] as PropType<string | unknown>, required: true },
  isCode: { type: Boolean, default: true },
  isFunds: { type: Boolean, default: false },
  isTranslatedMessage: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;
const { t, te } = useI18n({ useScope: 'global' });

const errorMessage = computed(() => {
  if (props.isTranslatedMessage) {
    return props.error;
  }

  if (props.isFunds) {
    const er = getFundingError(props.error);

    return te(`modules.funds.api.errors.${er}`) ? t(`modules.funds.api.errors.${er}`) : t('modules.funds.api.errors.UNKNOWN');
  }

  if (props.isCode && typeof props.error === 'string') {
    return te(props.error) ? t(props.error) : t('modules.transactions.errors.unknown', { error: props.error.replace('modules.transactions.errors.', '') });
  }

  return props.error;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(errorMessage.value), 1))
}
}

})